<input
  #input
  matInput
  [(ngModel)]="_value"
  (dateChange)="updateChanges($event)"
  [matDatepicker]="datePicker"
  placeholder="JJ/MM/AAAA"
/>
<mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
<mat-datepicker #datePicker></mat-datepicker>
